import { combineReducers } from 'redux'
import details from './details'

export default combineReducers({
  details,
})
